<template>
  <div class="type-body-sm flex flex-row gap-sm">
    <span
      class="whitespace-nowrap text-avtalat-secondary"
      data-testid="arende-id"
      ><FontAwesomeIcon
        class="text-avtalat-teal"
        icon="fa-regular fa-hashtag fa-sm"
      />
      {{ id }}</span
    >
    <time class="text-avtalat-secondary" :datetime="date"
      ><FontAwesomeIcon
        class="text-avtalat-teal"
        icon="fa-regular fa-calendar fa-sm"
      />
      {{ date }}</time
    >
  </div>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCalendar, faHashtag } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

type ArendeIdDateProps = {
  id?: string | number | null;
  date?: string;
};
defineProps<ArendeIdDateProps>();

library.add(faHashtag, faCalendar);
</script>
